import React from 'react';

import { ImageWidgetProps } from './imageWidgetProps';

import './imageWidget.scss';

const ImageWidget: React.FC<ImageWidgetProps> = ({ imageSrc, imageFile, title, type, description, navigationUrl }) => {

  return (
    <div className={`image-widget-wrapper`}>
      {navigationUrl ? <a className='image-content-wrapper' href={navigationUrl} target='_blank'>
        {imageSrc && <img src={imageSrc} alt={title} />}
        {imageFile && <img src={`data:image/png;base64,${imageFile}`} alt={title} />}
        <div className={`image-content-info ${!imageSrc ? 'content-info-without-img' : ''}`}>
          {title && <span className='image-widget-title'>{title}</span>}
          {type === 'image' && description && <p>{description}</p>}
          {type === 'html' && description && (
            <div className={'html-content-wrapper'}>
              <div dangerouslySetInnerHTML={{ __html: description || '' }} />
            </div>
          )}
        </div>
      </a> : <div className='image-content-wrapper'>
        {imageSrc && <img src={imageSrc} alt={title} />}
        {imageFile && <img src={`data:image/png;base64,${imageFile}`} alt={title} />}
        <div className={`image-content-info ${!imageSrc ? 'content-info-without-img' : ''}`}>
          {title && <span className='image-widget-title'>{title}</span>}
          {type === 'image' && description && <p>{description}</p>}
          {type === 'html' && description && (
            <div className={'html-content-wrapper'}>
              <div dangerouslySetInnerHTML={{ __html: description || '' }} />
            </div>
          )}
        </div>
      </div>}
    </div>
  );
};
export default ImageWidget;